import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';

interface VisitSidebarTabsProps {
  activeTab: 'claim' | 'clinical';
  claimCount: number;
  onTabChange: (tab: 'claim' | 'clinical') => void;
}

export const VisitSidebarTabs = ({
  activeTab,
  claimCount,
  onTabChange,
}: VisitSidebarTabsProps) => {
  return (
    <div className="vai-flex vai-justify-center vai-mb-3">
      <div className="vai-relative vai-flex vai-h-7 vai-w-[150px] vai-rounded-md vai-bg-[#292E3B] vai-p-1">
        <button
          className={classNames(
            'vai-flex-1 vai-rounded-sm vai-px-3 vai-text-[12px] vai-font-medium vai-leading-4 vai-text-zinc-400',
            {
              'vai-bg-black vai-text-zinc-50 vai-shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]':
                activeTab === 'clinical',
            },
          )}
          onClick={() => onTabChange('clinical')}
          type="button"
        >
          <Trans>Clinical</Trans>
        </button>
        <button
          className={classNames(
            'vai-flex-1 vai-rounded-sm vai-px-3 vai-text-[12px] vai-font-medium vai-leading-4 vai-text-zinc-400',
            {
              'vai-bg-black vai-text-zinc-50 vai-shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]':
                activeTab === 'claim',
            },
          )}
          onClick={() => onTabChange('claim')}
          type="button"
        >
          <Trans>Claim</Trans>
        </button>
        {claimCount > 0 && (
          <div className="vai-absolute vai-right-[9px] vai-top-[8px] vai-flex vai-h-3 vai-min-w-3 vai-items-center vai-justify-center vai-rounded-full vai-bg-[#D4A700] vai-px-1">
            <span className="vai-text-[8px] vai-font-semibold vai-leading-none vai-text-[#292E3B]">
              {claimCount}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
